export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyC8Tcr-0A9ePLEMMDeGP7npK8NxjXANuSs",
        authDomain: "handelsschule-raeber-7w0o6.firebaseapp.com",
        databaseURL: "https://handelsschule-raeber-7w0o6-default-rtdb.firebaseio.com",
        projectId: "handelsschule-raeber-7w0o6",
        storageBucket: "handelsschule-raeber-7w0o6.appspot.com",
        messagingSenderId: "182926189493",
        appId: "1:182926189493:web:ebf219a56d01484fbe2ffc",
        measurementId: "G-2ZQSPL632H"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts